import type { FindingOut } from '@/api/types';

/** Hard cap on the free-text search input. Keeps the substring scan
 *  bounded against tampering / huge paste accidents. */
export const SEARCH_QUERY_MAX_LENGTH = 100;

/** Returns true iff any searched field on `finding` contains `q`
 *  case-insensitively. Caller MUST pass `q` already lowercased + trimmed
 *  to keep the inner loop tight.
 *
 *  Fields searched (mirrors the free-text scope agreed with Andrew):
 *  - `rule_id`, `transaction_id`
 *  - every string value in `evidence` (covers gl_account.name,
 *    supplier.name, supplier.bn, transaction_type, tax_code, etc.)
 *  - `reviewer_alias`, `approval_note`, `rejection_reason`, `review_note`
 *  - `memo_text` (concatenated journal-entry memos for NetSuite runs)
 *
 *  Short-circuits on the first hit. */
export function findingMatchesSearch(finding: FindingOut, q: string): boolean {
  if (!q) return true;
  if (finding.rule_id.toLowerCase().includes(q)) return true;
  if (finding.transaction_id.toLowerCase().includes(q)) return true;
  for (const value of Object.values(finding.evidence)) {
    if (typeof value === 'string' && value.toLowerCase().includes(q)) {
      return true;
    }
  }
  const text = [
    finding.reviewer_alias,
    finding.approval_note,
    finding.rejection_reason,
    finding.review_note,
    finding.memo_text,
  ].filter((s): s is string => typeof s === 'string');
  for (const s of text) {
    if (s.toLowerCase().includes(q)) return true;
  }
  return false;
}
